import React from 'react'
import { useConflicts } from 'api/hooks/use-conflicts'
import Table from 'react-bootstrap/Table'
import TableFooter from 'shared/tables/table-footer'
import TableLoading from 'shared/tables/table-loading'
import Badge from 'react-bootstrap/Badge'
import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faBan } from '@fortawesome/free-solid-svg-icons'

function ConflictTable({ filterParams, setFilterParams }) {
  const navigate = useNavigate()
  const { data, isSuccess, isLoading } = useConflicts({ params: filterParams })

  return (
    <>
      <Table responsive hover size="sm" style={{ cursor: 'pointer' }}>
        <thead>
          <tr>
            <th>Duty</th>
            <th>Conflicting Duty</th>
            <th>Status</th>
            <th>Users</th>
            <th>Roles</th>
          </tr>
        </thead>
        <tbody>
          {isLoading && <TableLoading columns={5} />}
          {isSuccess &&
            data.data.map((conflict) => (
              <tr
                key={`${conflict.id}`}
                className={conflict.enabled ? '' : 'text-muted'}
                onClick={() => navigate(`/conflicts/${conflict.id}`)}
              >
                <td>{conflict.name.split(' - ')[0]}</td>
                <td>{conflict.name.split(' - ')[1]}</td>
                <td>
                  {/* Conflict enabled status - toggle available on show page */}
                  {conflict.enabled ? (
                    <Badge className="badge-primary fw-normal">
                      <FontAwesomeIcon icon={faCheck} className="me-1" />
                      On
                    </Badge>
                  ) : (
                    <Badge className="badge-secondary fw-normal">
                      <FontAwesomeIcon icon={faBan} className="me-1" />
                      Off
                    </Badge>
                  )}
                </td>
                <td className="text-muted">{conflict.employees_count}</td>
                <td className="text-muted">{conflict.roles_count}</td>
              </tr>
            ))}
        </tbody>
      </Table>
      <div className="my-4">
        {isSuccess && (
          <TableFooter
            meta={data.meta}
            params={filterParams}
            setParams={setFilterParams}
          />
        )}
      </div>
    </>
  )
}

export default ConflictTable
